<template>
  <div class="fts-list-designer">
    <!-- header -->
    <div class="list-designer-header">
      <div class="list-designer-header-l">
        <div class="list-designer-header-title">{{title}}</div>
      </div>
      <fts-btn text icon @click="openColumnsSelection">
        <font-awesome-icon :icon="['fas', 'edit']" fixed-width /> 
      </fts-btn>
    </div>
    <!-- content -->
    <div class="list-designer-content fts-scrollbar">
      <fts-list-designer-layouter
        :list="list"
        :wrap="false"
        class="list-designer-columns" 
        @input="onInput"
      />
    </div>
    <!-- overlay -->
    <div class="list-designer-overlay" v-if="list.columns && !list.columns.length" @click="openColumnsSelection">
      <div class="overlay-label">Click to customize your list !</div>
    </div>
    <!-- listing column design modal -->
    <fts-listing-column-design-modal
      :title="title"
      :columns="list.columns"
      ref="ftsListingColumnDesignModal"
    />
  </div>
</template>

<script>
import queryLogic from "../commons/queryLogic";

import FTSListDesignerLayouter from "./FTSListDesignerLayouter";
import FTSListingColumnDesignModal from "./FTSListingColumnDesignModal";

import FTSBtn from "../elements/FTSBtn";

export default {
  props: {
    title: {
      type: String,
      default: "List design"
    },
    informationSource: {
      type: Array,
      default: () => []
    },
    list: {
      type: Object,
      default: () => ({})
    },
    userCollection: Boolean,
  },
  model: {
    prop: "list",
    event: "updateList",
  },
  components: {
    "fts-list-designer-layouter": FTSListDesignerLayouter,
    "fts-listing-column-design-modal": FTSListingColumnDesignModal,
    "fts-btn": FTSBtn,
  },
  methods: {
    onInput() {
      this.$emit('input');
    },
    async openColumnsSelection() {
      const res = await this.$refs.ftsListingColumnDesignModal.show(this.selection);
      if (res !== null && res !== true) {
        res.forEach(selectItem => {
          if (
            !this.list.columns.some(x =>
              x.fieldName == selectItem.fieldName &&
              x.system == selectItem.system
            )
          ) {
            delete selectItem.selected;
            this.list.columns.push(selectItem);
          }
        });

        let columns = this.list.columns.slice();
        columns.forEach(column => {
          if (
            !res.some(
              x => x.fieldName == column.fieldName && x.system == column.system
            )
          ) {
            let ind = this.list.columns.indexOf(column);
            this.list.columns.splice(ind, 1);
          }
        });
      
        this.onInput();
      } else if (res === true) {
        this.list.columns = [];
      }
    },
  },
  computed: {
    selection() {
      const difference = ["collaboration", "due"];
      return _.differenceWith(
        queryLogic.querySelectionPrefix,
        this.userCollection ? difference : [...difference, "username"],
        ({ id }, key) => id === key
      ).concat(this.informationSource);
    }
  },
  mounted() {
    if (!Array.isArray(this.list.columns)) {
      this.$emit('updateList', {columns: []})
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.fts-list-designer {
  position: relative;
  border-radius: .25rem;
  background: #f8f8f8;
  .list-designer-header {
    display: flex;
    align-items: center;
    padding: 1rem 1rem 0;
    .list-designer-header-l {
      flex: 1;
      margin-right: .75rem;
      .list-designer-header-title {
        font-size: 1.15rem;
        font-weight: 500;
        color: $grayColor;
      }
    }
  }
  .list-designer-content {
    min-height: 90px;
    display: flex;
    .list-designer-columns {
      padding: 0 1rem 1rem;
    }
  }
  .list-designer-overlay {
    @include flex-center-middle;
    @include position($top: 0, $left: 0, $right: 0, $bottom: 0);
    border-radius: inherit;
    background: rgba($color: #f8f8f8, $alpha: .85);
    cursor: pointer;
    .overlay-label {
      color: $grayColor;
      font-size: 1.15rem;
      font-weight: 500,
    }
  }
}
</style>





        